// The sign-mode route expects the user's auth token in the `key` query param;
// reading from localStorage at call time so the URL reflects the current
// session.
const buildSignUrl = (workflowId: string, signerId: string): string => {
  const token = localStorage.getItem('token') ?? '';
  return `/sign/${workflowId}/${signerId}?key=${encodeURIComponent(token)}`;
};

export default buildSignUrl;
